/*
 * Copyright (c) 2021. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import React, { useState } from "react";
import { Button, Drawer, Typography } from "@mui/material";
import Grid from "@mui/material/Grid";
import CookieModal from "./CookieModal";
import { useCookieConsent } from "@/src/provider/CookieConsent/CookieConsentProvider";
import LinkLegalbird from "@/src/components/legalbird/LinkLegalbird/LinkLegalbird";
import { SettingsOutlined } from "@mui/icons-material";

const CookieBanner = () => {
  const { allowAll, denyAll, showCookieBanner } = useCookieConsent();
  const [isConfigureOpen, setIsConfigureOpen] = useState(false);
  const [isSelectionMade, setIsSelectionMade] = useState(false);

  if (isSelectionMade || !showCookieBanner) {
    return null;
  }

  return (
    <Drawer
      variant={"permanent"}
      anchor={"bottom"}
      slotProps={{
        paper: {
          sx: {
            padding: "1rem",
          },
        },
      }}
    >
      <Grid container spacing={2}>
        <Grid>
          <Typography variant={"h7"} component={"h2"} sx={(theme) => ({ color: theme.palette.text.secondary })}>
            Schutz Ihrer Daten
          </Typography>
          <Typography variant={"body3"} sx={(theme) => ({ color: theme.palette.text.secondary })}>
            Für ein optimales Website-Erlebnis nutzen wir Cookies und ähnliche Technologien, um personalisierte Inhalte zu zeigen, Funktionen anzubieten und
            Statistiken zu erheben. Ein Klick auf "Akzeptieren" erlaubt uns diese Datenverarbeitung sowie die Weitergabe an Drittanbieter gemäß unserer
            Datenschutzerklärung. Personalisieren Sie ihre Cookie-Einstellungen (dies ist auch nachträglich jederzeit im Bereich Datenschutz möglich) oder
            klicken Sie auf "Ablehnen", wenn Sie nicht möchten, dass wir Cookies zu diesem Zweck verwenden.
          </Typography>
        </Grid>

        <Grid size={{ xs: 12, md: 7 }} sx={{ marginTop: "1rem", marginBottom: "1.5rem" }}>
          <Typography variant="body3" sx={(theme) => ({ color: theme.palette.text.secondary })}>
            Weitere Informationen finden Sie unter{" "}
            <LinkLegalbird to={"datenschutz"} standalone>
              Datenschutzerklärung
            </LinkLegalbird>
            ,{" "}
            <LinkLegalbird to={"agb"} standalone>
              AGB
            </LinkLegalbird>{" "}
            oder{" "}
            <LinkLegalbird to={"impressum"} standalone>
              Impressum
            </LinkLegalbird>
            .
          </Typography>
        </Grid>

        <Grid container size={{ xs: 12, md: 5 }} spacing={1}>
          <Grid size={{ xs: 12, md: 4 }} sx={{ order: { xs: 3, md: 1 } }}>
            <Button fullWidth onClick={() => setIsConfigureOpen(true)} color={"primary"} startIcon={<SettingsOutlined />}>
              Einstellungen
            </Button>
          </Grid>
          <Grid size={{ xs: 6, md: 4 }} sx={{ order: { xs: 1, md: 2 } }}>
            <Button
              fullWidth
              variant={"outlined"}
              onClick={() => {
                setIsSelectionMade(true);
                denyAll();
              }}
            >
              Ablehnen
            </Button>
          </Grid>
          <Grid size={{ xs: 6, md: 4 }} sx={{ order: { xs: 2, md: 3 } }}>
            <Button
              fullWidth
              variant={"contained"}
              onClick={() => {
                setIsSelectionMade(true);
                allowAll();
              }}
            >
              Akzeptieren
            </Button>
          </Grid>
        </Grid>
      </Grid>

      <CookieModal isSelectionMade={isSelectionMade} setIsSelectionMade={setIsSelectionMade} open={isConfigureOpen} setIsConfigureOpen={setIsConfigureOpen} />
    </Drawer>
  );
};

export default CookieBanner;
